// extracted by mini-css-extract-plugin
export default {"MyLoader":"MyLoader_MyLoader__Q4FTo"};